<template>
  <div class="invest-form">
    <section class="page-section">
      <div class="container form-section">
        <div class="row">
          <div class="col-md-7">
            <div class="row">
              <div class="col-md-10 offset-md-2">
                <h1 class="section-title">
                  {{ $t('form.invest.title') }}
                </h1>
                <label class="fz-13">{{ $t('form.invest.subtitle') }}</label>
                <br>
              </div>
              <div class="col-md-10 offset-md-2">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="label-required">{{ $t('form.invest.string.you_type') }}</label>
                      <div class="row">
                        <template v-for="(item, key) of investType">
                          <template v-if="item.name === 'Other'">
                            <div
                              class="col-md-12 pt-2 pb-2"
                              :key="key"
                            >
                              <div class="custom-control custom-radio">
                                <input
                                  v-model="investTypeId"
                                  class="custom-control-input"
                                  type="radio"
                                  name="invest-type"
                                  :id="item.name"
                                  :value="item.id"
                                >
                                <label
                                  class="custom-control-label"
                                  :for="item.name"
                                >{{ item.name }}</label>
                              </div>
                            </div>
                            <div
                              :key="`_id_3_${key}`"
                              v-if="investTypeId === 3"
                              class="col-md-12 pt-2 pb-2"
                            >
                              <input
                                type="text"
                                class="form-control form-input"
                                v-model="otherValue"
                              >
                            </div>
                          </template>
                          <template v-else>
                            <div
                              class="col-md-12 pt-2 pb-2"
                              :key="`invest_type_id_${key}`"
                            >
                              <div class="custom-control custom-radio">
                                <input
                                  v-model="investTypeId"
                                  class="custom-control-input"
                                  type="radio"
                                  name="invest-type"
                                  :id="item.name"
                                  :value="item.id"
                                >
                                <label
                                  class="custom-control-label"
                                  :for="item.name"
                                >{{ item.name }}</label>
                              </div>
                            </div>
                          </template>
                        </template>
                      </div>
                    </div>
                  </div>
                  <template v-if="investTypeId !== '' && investType !== null">
                    <div class="col-md-12 mt-2 mb-2">
                      <div class="form-group">
                        <label
                          class="label-required"
                          v-if="investTypeId === 1"
                        >{{ $t('form.invest.label.your_company_name') }}</label>
                        <label
                          class="label-required"
                          v-else-if="investTypeId === 2"
                        >{{ $t('form.invest.label.your_name') }}</label>
                        <label
                          class="label-required"
                          v-else
                        >{{ $t('form.invest.label.otherName') }}</label>
                        <input
                          v-validate="'required'"
                          name="name"
                          type="text"
                          class="form-control form-input"
                          v-model="name"
                          :class="messageValidate && messageValidate.hasOwnProperty('name') ? 'form-input-error': '' "
                          :placeholder="$t('borrow.placeholder.name')"
                        >
                        <span
                          class="label-error"
                          v-if="messageValidate && messageValidate.hasOwnProperty('name')"
                        >
                          {{ messageErrorLabels.name }}
                        </span>
                      </div>
                    </div>
                    <div class="col-md-12 mt-2 mb-2">
                      <div class="form-group">
                        <label class="label-required">{{ $t('form.invest.string.amount') }}</label>
                        <input
                          type="number"
                          name="amount"
                          class="form-control form-input"
                          v-model="amount"
                          mix="0"
                          v-validate="'required'"
                          :class="messageValidate && messageValidate.hasOwnProperty('amount') ? 'form-input-error': '' "
                          :placeholder="$t('borrow.placeholder.amount')"
                        >
                        <span
                          class="label-error"
                          v-if="messageValidate && messageValidate.hasOwnProperty('amount')"
                        >
                          {{ messageErrorLabels.amount }}
                        </span>
                      </div>
                    </div>
                    <div class="col-md-12 mt-2 mb-2">
                      <div class="form-group">
                        <label>{{ $t('form.invest.string.expectedProfit') }}</label>
                        <div class="row">
                          <div class="col-md-12 pt-2 pb-2">
                            <div class="custom-control custom-radio">
                              <input
                                v-model="expectRate"
                                class="custom-control-input"
                                type="radio"
                                name="invest-expect-rate"
                                id="2-5"
                                value="2-5$"
                              >
                              <label
                                class="custom-control-label"
                                for="2-5"
                              >{{ $t('form.invest.string.2-5%') }}</label>
                            </div>
                          </div>
                          <div class="col-md-12 pt-2 pb-2">
                            <div class="custom-control custom-radio">
                              <input
                                v-model="expectRate"
                                class="custom-control-input"
                                type="radio"
                                name="invest-expect-rate"
                                id="6-8"
                                value="6-8%"
                              >
                              <label
                                class="custom-control-label"
                                for="6-8"
                              >{{ $t('form.invest.string.6-8%') }}</label>
                            </div>
                          </div>
                          <div class="col-md-12 pt-2 pb-2">
                            <div class="custom-control custom-radio">
                              <input
                                v-model="expectRate"
                                class="custom-control-input"
                                type="radio"
                                name="invest-expect-rate"
                                id="9-10"
                                value="9-10%"
                              >
                              <label
                                class="custom-control-label"
                                for="9-10"
                              >{{ $t('form.invest.string.8-10%') }}</label>
                            </div>
                          </div>
                          <span
                            class="col-md-12 label-error"
                            v-if="messageValidate && messageValidate.hasOwnProperty('profit_expectation')"
                          >
                            {{ messageErrorLabels.profit_expectation }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 mt-2 mb-2">
                      <div class="form-group">
                        <label class="label-required">{{ $t('form.invest.label.contact_number') }}</label>
                        <input
                          type="text"
                          name="contact_number"
                          class="form-control form-input"
                          v-validate="'required'"
                          v-mask="'0## ### ####'"
                          v-model="contact"
                          :class="messageValidate && messageValidate.hasOwnProperty('phone') ? 'form-input-error': '' "
                          :placeholder="$t('borrow.placeholder.phone')"
                        >
                        <span
                          class="label-error"
                          v-if="messageValidate && messageValidate.hasOwnProperty('phone')"
                        >
                          {{ messageErrorLabels.phone }}
                        </span>
                      </div>
                    </div>
                    <div class="col-md-12 mt-2 mb-2">
                      <div class="form-group">
                        <label class="label-required">{{ $t('form.invest.label.note') }}</label>
                        <textarea
                          name="note"
                          class="form-control form-input"
                          v-validate="'required'"
                          v-model="note"
                          rows="5"
                          :class="messageValidate && messageValidate.hasOwnProperty('note') ? 'form-input-error': '' "
                          :placeholder="$t('borrow.placeholder.note')"
                        />
                        <span
                          class="label-error"
                          v-if="messageValidate && messageValidate.hasOwnProperty('note')"
                        >
                          {{ messageErrorLabels.note }}
                        </span>
                      </div>
                    </div>
                    <div class="col-md-12 mt-3 mb-2">
                      <div class="form-group">
                        <g-recaptcha
                          :sitekey="sitekey"
                          :callback="callback"
                        />
                        <span
                          class="label-error"
                          v-if="messageValidate && messageValidate.hasOwnProperty('recaptcha_response')"
                        >
                          {{ messageErrorLabels.recaptcha_response }}
                        </span>
                      </div>
                    </div>
                    <div class="col-md-12 mt-3">
                      <button
                        class="full-button"
                        @click="submitFormInvest"
                      >
                        {{ $t('referral.button.submit').toUpperCase() }}
                      </button>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-5 block-img d-none d-md-block">
            <img
              src="img/cashHero.png"
              alt=""
              style="width: 60%;"
            >
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'
import gRecaptcha from './../../components/recaptcha.vue'
export default {
  name: 'Invest',
  metaInfo: {
    title: 'Invest Form',
    titleTemplate: '%s | Cash Hero',
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: 'Cash hero Invest Form' }
    ]
  },
  directives: { mask },
  components: { gRecaptcha },
  data () {
    return {
      investType: [],
      investTypeId: '',
      otherValue: '',
      name: '',
      amount: '',
      contact: '',
      note: '',
      expectRate: '',
      messageValidate: null,
      baseUrl: process.env.VUE_APP_BASE_URL,
      sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      recaptchaToken: null,
      messageErrorLabels: {
        self: this,
        get name () { return this.self.$t('messageError.label.nameInvest') },
        get amount () { return this.self.$t('messageError.label.amountInvest') },
        get note () { return this.self.$t('messageError.label.noteInvest') },
        get phone () { return this.self.$t('messageError.label.phone') },
        get profit_expectation () { return this.self.$t('messageError.label.profitExpectation') },
        get recaptcha_response () { return this.self.$t('messageError.label.recaptcha') }
      }
    }
  },
  methods: {
    splitSpace (string) {
      return string.split(' ').join('')
    },
    getInvestType () {
      this.$axios.get(this.baseUrl + '/api/v1/invests/get-invest-type')
        .then((response) => {
          if (response.data.code === 1) {
            this.investType = response.data.data
          }
        })
    },
    callback (token) {
      this.recaptchaToken = token
    },
    resetRecaptcha () {
      window.grecaptcha.reset(0)
      this.recaptchaToken = null
    },
    submitFormInvest () {
      this.messageValidate = ''
      this.$axios.post(this.baseUrl + '/api/v1/invests/store', {
        invest_type_id: this.investTypeId,
        name: this.name,
        amount: this.amount,
        phone: this.splitSpace(this.contact),
        note: this.note,
        profit_expectation: this.expectRate,
        recaptcha_response: this.recaptchaToken
      }).then((response) => {
        if (response.data.code === 1) {
          this.resetRecaptcha()
          this.$swal.fire({
            type: 'success',
            title: this.$t('messageSuccess.title.submitBorrow'),
            text: this.$t('messageSuccess.label.submitInvest'),
            confirmButtonColor: '#3c56a0'
          })
          // change redirect to home page
          this.$router.push({ name: this.$default_page })
        } else {
          this.messageValidate = response.data.message
          if (typeof this.messageValidate === 'object') {
            this.$swal.fire({
              type: 'error',
              title: 'Oops...',
              html: this.generateMessageError(),
              confirmButtonColor: '#3c56a0'
            })
          } else {
            this.$swal.fire({
              type: 'error',
              title: this.$t('messageError.title.serverError'),
              text: this.$t('messageError.label.serverError'),
              confirmButtonColor: '#3c56a0'
            })
          }
          $(document).scrollTop(0)
        }
      })
    },
    generateMessageError () {
      const generateListItem = (value) => {
        if (value) {
          return '<li>' + value + " <i class='fas fa-times' style='color: var(--danger)'></i></li>"
        } else {
          return ''
        }
      }

      let errorMessage = "<ul class='text-left list-unstyled ml-4 pl-2' style='line-height: 1.5'>"
      for (const errorField in this.messageValidate) {
        errorMessage += generateListItem(this.messageErrorLabels[errorField])
      }

      return errorMessage + '</ul>'
    }
  },
  mounted () {
    this.getInvestType()
  }
}
</script>

<style scoped>
  .section-title {
    margin-bottom: 20px !important;
  }

  .fz-13 {
    font-size: 13px;
  }

  .block-img {
    text-align: right;
    padding-top: 75px;
  }

  @media screen and (max-width: 991px) {
    .block-img {
      text-align: center;
      padding-top: 50px;
    }

    .form-section {
      margin: 3rem auto 0 auto;
    }
  }

  @media screen and (max-width: 767px) {
    .section-title {
      text-align: center;
    }
  }
</style>
